let installed = false;

const isKnownExternalMutationError = (error: unknown): boolean => {
  if (!(error instanceof DOMException) || error.name !== 'NotFoundError') {
    return false;
  }

  return error.message.includes('not a child of this node');
};

export const installDomMutationGuard = (): void => {
  if (installed || typeof window === 'undefined' || typeof Node === 'undefined') {
    return;
  }

  installed = true;

  const originalRemoveChild = Node.prototype.removeChild;

  Node.prototype.removeChild = function guardedRemoveChild<T extends Node>(child: T): T {
    try {
      return originalRemoveChild.call(this, child) as T;
    } catch (error) {
      if (isKnownExternalMutationError(error)) {
        return child;
      }
      throw error;
    }
  };
};
